import { InjectionToken } from '@angular/core';
import { Window } from '../tpi-models/general/model-window';

export interface PolicyRequestsConfig {
    apigeeEnvironment: string;
    authorize: { client_id: string };
    displaySystemDownMessage: boolean;
    enterpriseUserAuth: string;
    gisEndPoint: string;
    PING: {
        authorizeUrl: string;
        authWellknownEndpointUrl: string;
        logoutUrl: string;
        redirectUri: string;
        userInfoUrl: string;
    };
    tokenTimeout: number;
    tpiSession: string;
}

export const WINDOW_TOKEN = new InjectionToken<Window>('window');
export const POLICY_REQUESTS_CONFIG = new InjectionToken<PolicyRequestsConfig>('policyRequestsConfig');